import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState, useRef } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import i18n from 'i18next';
import moment from 'moment';
import { TablePagination } from '@material-ui/core';
import ModalDialog from '../ui/modal-dialog';
import DateRange from '../ui/react-ui/date-range';
import DataTable from '../ui/table'; // api

import { getAuditLogList } from '../../api/settingAPI';
var t = i18n.getFixedT(null, 'setting-service');
var at = i18n.getFixedT(null, 'audit-log');
var gt = i18n.getFixedT(null, 'app');
var DataProvideRecordSearch = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      dialogInfo = _useSelector.service.dialogInfo;

  var onClose = props.onClose,
      id = props.id;
  var initDateTime = {
    from: moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm'),
    to: moment().format('YYYY-MM-DD HH:mm')
  };

  var _useState = useState(initDateTime),
      _useState2 = _slicedToArray(_useState, 2),
      dateTime = _useState2[0],
      setDateTime = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      currentPage = _useState4[0],
      setCurrentPage = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      totalCount = _useState6[0],
      setTotalCount = _useState6[1];

  var _useState7 = useState(10),
      _useState8 = _slicedToArray(_useState7, 2),
      rowsPerPage = _useState8[0],
      setRowsPerPage = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      tableData = _useState10[0],
      setTableData = _useState10[1];

  var _useState11 = useState({
    field: 'dateTime',
    desc: true
  }),
      _useState12 = _slicedToArray(_useState11, 2),
      tableSort = _useState12[0],
      setTableSort = _useState12[1];

  var isMounted = useRef(false);
  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-close'),
    handler: onClose
  });

  var handleChangePage = function handleChangePage(e, newPage) {
    setCurrentPage(newPage);
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  var handleChangeDateTime = function handleChangeDateTime(dateTime) {
    setDateTime(dateTime);
  };

  var handleSort = function handleSort(sort) {
    setTableSort(sort);
  };

  var fetchData = function fetchData() {
    var moduleName = dialogInfo.data.moduleName;
    var offset = (Number(currentPage + 1) - 1) * rowsPerPage;
    getAuditLogList(contextRoot, false, null, dateTime, tableSort, offset, rowsPerPage, moduleName).then(function (result) {
      var newData = _.map(result.content, function (el, index) {
        return _objectSpread(_objectSpread({}, el), {}, {
          sequence: offset + index + 1
        });
      });

      setTableData(newData);
      setTotalCount(result.totalElements);
    });
  };

  useEffect(function () {
    if (!isMounted.current) return;
    fetchData();
  }, [JSON.stringify(tableSort), currentPage, rowsPerPage]);
  useEffect(function () {
    if (!isMounted.current) {
      isMounted.current = true;
      fetchData();
    }
  }, []);
  var fields = {};

  _.set(fields, 'sequence', {
    label: at('lbl-sequence')
  });

  _.set(fields, 'moduleName', {
    label: at('lbl-module-name'),
    sortable: true
  });

  _.set(fields, 'actionName', {
    label: at('lbl-action-name'),
    sortable: true
  });

  _.set(fields, 'target', {
    label: at('lbl-target'),
    sortable: true
  });

  _.set(fields, 'userName', {
    label: at('lbl-username'),
    sortable: true
  });

  _.set(fields, 'displayName', {
    label: at('lbl-display-name'),
    sortable: true
  });

  _.set(fields, 'ip', {
    label: at('lbl-ip'),
    sortable: true
  });

  _.set(fields, 'dateTime', {
    label: at('lbl-date-time'),
    sortable: true
  });

  _.set(fields, 'actionResult', {
    label: at('lbl-action-result'),
    sortable: true,
    formatter: function formatter(value) {
      if (value === 0) return /*#__PURE__*/React.createElement("div", null, at('lbl-action-result-success'));
      if (value === 1) return /*#__PURE__*/React.createElement("div", null, at('lbl-action-result-failed'));
      return '';
    }
  });

  _.set(fields, 'severity', {
    label: at('lbl-severity'),
    sortable: true,
    formatter: function formatter(value) {
      if (value === 1) return /*#__PURE__*/React.createElement("div", null, at('lbl-severity-low'));
      if (value === 2) return /*#__PURE__*/React.createElement("div", null, at('lbl-severity-medium'));
      if (value === 3) return /*#__PURE__*/React.createElement("div", null, at('lbl-severity-high'));
      return '';
    }
  });

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    title: t('lbl-interface-record') + " - ".concat(dialogInfo.data.moduleName),
    global: true,
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "date-select"
  }, /*#__PURE__*/React.createElement(DateRange, {
    id: "datetime",
    enableTime: true,
    enableStartEndLabel: true,
    startLabel: t('lbl-start-time'),
    endLabel: t('lbl-end-time'),
    onChange: handleChangeDateTime,
    value: dateTime,
    limitRange: '30d'
  }), /*#__PURE__*/React.createElement("button", {
    className: "button",
    onClick: function onClick() {
      return fetchData();
    }
  }, gt('global.lbl-search'))), /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: tableData,
    sort: tableSort,
    onSort: handleSort
  })), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: t('lbl-per-page-row-count'),
    count: totalCount,
    page: currentPage,
    onChangePage: handleChangePage,
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  })));
});
DataProvideRecordSearch.defaultProps = {
  id: 'g-data-provide-record-search'
};
DataProvideRecordSearch.propTypes = {
  id: PropTypes.string
};
export default DataProvideRecordSearch;